import { EntityConfig } from "../hooks/useEntity";

export interface SharedFile {
  id: string;
  userId: string; // owner (sender)
  roomId?: string;
  roomName?: string;
  targetUserId?: string; // for direct chats
  name: string;
  url: string;
  type: string;
  sharedBy: string;
  sharedByName: string;
  timestamp: string;
}

export const sharedFileEntityConfig: EntityConfig<SharedFile> = {
  entityType: "SharedFile",
  properties: {
    userId: { type: "string", required: true },
    roomId: { type: "string", required: false },
    roomName: { type: "string", required: false },
    targetUserId: { type: "string", required: false },
    name: { type: "string", required: true },
    url: { type: "string", required: true },
    type: { type: "string", required: true },
    sharedBy: { type: "string", required: true },
    sharedByName: { type: "string", required: true },
    timestamp: { type: "string", required: true },
  },
  orderBy: { field: "timestamp", direction: "desc" },
};
